import { render, staticRenderFns } from "./CustomersLoyaltiesV2.vue?vue&type=template&id=5042549a&scoped=true"
import script from "./CustomersLoyaltiesV2.vue?vue&type=script&lang=js"
export * from "./CustomersLoyaltiesV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042549a",
  null
  
)

export default component.exports